<template>
  <div class="content d-flex justify-content-center align-items-center" style="background-color: #364150;">
    <div class="container" >
        <div class="row justify-content-md-center">
            <div class="col-md-5">
                <div class="text-center mb-4"><img src="../assets/light-logo.webp" alt="INSE logo" width="200" /></div>
                <div class="card">
                    <div class="card-body">
                        <legend class="font-weight-semibold text-uppercase font-size-sm text-left">Login</legend>
                        <form action="#" @submit.prevent="login">
                            <div class="form-group text-left">
                                <label>Account</label>
                                <select v-model="accountId" class="form-control">
                                  <option :key="account._id" v-for="account in accounts" :value="account._id">{{account.account}}</option>
                                </select>
                            </div>
                            <div class="form-group text-left">
                                <label>Username</label>
                                <input class="form-control" type="text" placeholder="username" @input="setErrorMsg('')" v-model="user">
                            </div>
                            <div class="form-group text-left">
                                <label>Password</label>
                                <input class="form-control" type="password" placeholder="password" @input="setErrorMsg('')" v-model="pass">
                            </div>
                            <div class="alert alert-danger" v-if="errorMsg">{{errorMsg}}</div>
                            <div class="form-group text-right">
                                <button class="btn btn-primary" type="submit">Login</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      user: '',
      pass: '',
      accountId: '5e16e8b46a9de4bbc14e119b' // kbank
    }
  },
  mounted () {
    this.getAccounts()
  },
  computed: {
    ...mapGetters({
      isAuth: 'isAuth',
      username: 'username',
      password: 'password',
      errorMsg: 'errorMsg',
      accounts: 'accounts'
    })
  },
  methods: {
    ...mapActions({
      auth: 'auth',
      setToken: 'setToken',
      setUserId: 'setUserId',
      setUsername: 'setUsername',
      setErrorMsg: 'setErrorMsg',
      getAccounts: 'getAccounts',
      setAccountId: 'setAccountId',
      setIsAuth: 'setIsAuth',
      setRole: 'setRole',
      setUserInfo: 'setUserInfo'
    }),
    async login () {
      this.auth({ username: this.user, password: this.pass }).then(res => {
        let responseData = res.data
        this.setIsAuth(responseData.auth)
        this.setRole(responseData.role)
        if (this.isAuth) {
          this.setToken(responseData.token)
          this.setUsername(this.user)
          this.setAccountId(this.accountId)
          this.setUserId(responseData._id)
          this.setUserInfo(responseData)
          this.$router.push({ path: '/' })
        }
      }).catch(() => {
        this.setToken(null)
        this.setRole(null)
        this.setUsername(null)
        this.setUserInfo(null)
        this.setErrorMsg('Username or password is not correct.')
      })
    }
  }
}
</script>
